<script setup lang="ts">
import { Page } from "@/components/Ui";
import { HeroPrivateV5 } from "@/components/Hero";
import {
  PrivateBestTerms,
  PrivateCardService,
  PrivateAnyFeatures,
  BaseAffiliate,
} from "@/components/Sections";
import { onEvent, onYMEvent } from "@/helpers/events";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useHead({
  htmlAttrs: {
    class: "dark",
  },
});

definePageMeta({
  page: "private",
});

onMounted(() => {
  onEvent("landing_privat_page-opened", null, {
    // "product name": "private",
  });
  if (window && window.ym) {
    onYMEvent("privat_page-opened");
  }
});

useSeoMeta({
  title: t("page.private.seo.title"),
  description: t("page.private.seo.description"),
  ogTitle: t("page.private.seo.title"),
  ogDescription: t("page.private.seo.description")
});
</script>

<template>
  <Page :class="$style.root">
    <HeroPrivateV5 class="z-40 mt-10 pb-4 md:pb-10" />
    <PrivateBestTerms class="z-30 mt-10 pb-4 md:pb-10" />
    <PrivateCardService class="z-20 pb-4 md:pb-10" />
    <PrivateAnyFeatures class="z-10 pb-4 md:pb-10" />
    <BaseAffiliate learn-more-event="landing_privat_button-6" />
  </Page>
</template>
<style lang="scss" module>
.root {
  @apply flex flex-col mt-[70px] md:mt-[90px];
}

.section {
  @apply w-full;
  &__title {
    @apply text-center px-4 font-light text-[40px] sm:text-[52px] leading-[123%];
  }

  &-wrapper {
    @apply w-full grid grid-cols-1 gap-5;
    @apply md:grid-cols-2;

    & > div {
      &:first-child {
        @apply md:col-span-2;
      }
    }
  }

  &-wrapper2 {
    & > div {
      &:last-child {
        @apply md:col-span-2;
      }
    }
  }
}
</style>
